export enum ExperimentType {
  CONVERSION = "conversion",
  CLASS = "class",
  LANDING = "landing",
  STORE = "store",
  EXTERNAL = "external",
  PLATFORM_LANDING = "platform_landing",
}

export enum ExperimentStatus {
  RUNNING = "running",
  PAUSED = "paused",
}

export interface Experiment {
  experimentId: string;
  type: ExperimentType;
  optionId?: string;
  values?: { [key: string]: any };
  expiredAt?: number;
  joined?: false | true;
  conditions?: [{ key: string }];
}

export interface ExperimentToolkit {
  id: string;
  type: ExperimentType;
  range: number;
  status: ExperimentStatus;
  values: Record<string, any>;
  buckets: number[];
  conditions?: [{ key: string }];
  conditions_dict?: ExperimentConditions;
}

export interface RawExperimentOption {
  values: { [key: string]: any } | string;
}

export interface RawExperiment {
  experimentId: string;
  type: ExperimentType;
  portion: number;
  kickstart?: boolean;
  options: { [key: string]: RawExperimentOption };
  ttlMillis: number;
  conditions?: { [key: string]: any };
}

export interface Booking {
  externalId?: string;
  eventSourceUrl: string;

  experiment?: Experiment;

  facebookClickId?: string | undefined;
  facebookBrowserId?: string | undefined;

  adjustWebUUID?: string | undefined;
  adjustTrackerId?: string | undefined;

  twitterClickId?: string | undefined;

  googleGclid?: string | undefined;
  googleWbraid?: string | undefined;
  googleGbraid?: string | undefined;

  oceanengineCampaign?: string | undefined;
  oceanengineCampaignId?: string | undefined;
  oceanengineAdGroup?: string | undefined;
  oceanengineCreative?: string | undefined;
  oceanengineCreativeId?: string | undefined;
  oceanengineClickId?: string | undefined;
}

export interface RawRemoteConfigParamValue {
  value?: string;
}

export interface RawRemoteConfigParam {
  defaultValue: RawRemoteConfigParamValue;
  conditionalValues: { [key: string]: RawRemoteConfigParamValue };
}

export interface RawRemoteConfig {
  parameters: { [key: string]: RawRemoteConfigParam };
}

export interface ExperimentConditions {
  [key: string]: string | string[];
}
export interface Terms {
  conditions: ExperimentConditions;
  default: string;
}

export interface ExperimentOption {
  version?: string;
  terms?: string | Terms;
  roadmap?: string;
}

export interface SplitOptions {
  experimentId: string;
  layer: ExperimentType;
  userId: string | number;
  experimentOptions: { [key: string]: ExperimentOption };
}

export interface UserExperiment {
  id: string;
  value: ExperimentOption;
  group: string;
  layer: ExperimentType;
  conditions?: ExperimentConditions;
}

export interface UserExperiments extends Array<UserExperiment> {}

export type AppliedValues = { [key in ExperimentType]?: any };

export type AppliedOptions = {
  [key in keyof ExperimentOption]?: string | Terms;
};

export interface AppliedConfig extends AppliedValues {
  userExperiments: UserExperiments;
  values: AppliedOptions;
  nativeLanguage?: string | null;
}

export interface Context {
  userId: string | number;
  campaign?: string | null;
  nativeLanguage?: string | null;
  country?: string | null;
  os: string | null;
  paid?: boolean | null;
  silent?: boolean;
  isCheckoutLayerAvailable?: boolean;
}
